import { DestinationTaskConfigBase } from '../../classes/config-objects/destination-service-config-base';

/**
 * A single branch entry for a ParallelSplit task. Holds a successMappingID
 * that the flow engine resolves to the first task of this parallel branch.
 */
export class ParallelSplitMapping extends DestinationTaskConfigBase {
	constructor(init?: Partial<ParallelSplitMapping>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}

	override GetDestinationTasks(): string[] {
		return [this.successMappingID];
	}
}
